import { Cartesian3 } from "cesium";
import { ERubbingDestination } from "../site/trench/types";
import { EarthBrainPlane } from "./earthbrain-plane";
export function getRaycastableFromRubbingDestination(site, rubbingDestination) {
    const intersectionData = [];
    switch (rubbingDestination.target) {
        case ERubbingDestination.POINT_CLOUD:
            const associatedPointCloud = site.getPointCloud(rubbingDestination.id);
            associatedPointCloud && intersectionData.push(associatedPointCloud);
            break;
        case ERubbingDestination.DESIGN_DATA:
            const associatedDesignData = site.getDesignData(rubbingDestination.id);
            associatedDesignData && intersectionData.push(associatedDesignData);
            break;
        case ERubbingDestination.FLAT_GROUND:
            const associatedFlatGround = site.getFlatGround(rubbingDestination.id);
            associatedFlatGround && intersectionData.push(associatedFlatGround);
            break;
        case ERubbingDestination.SPECIFIED_ALTITUDE:
            const pointAtSpecifiedAltitude = new Cartesian3(0, 0, rubbingDestination.specifiedAltitude);
            const planeAtSpecifiedAltitude = new EarthBrainPlane(pointAtSpecifiedAltitude, new Cartesian3(0, 0, 1));
            intersectionData.push(planeAtSpecifiedAltitude);
            break;
        case ERubbingDestination.REFERENCE_TOPOLOGY:
            const associatedTopology = site.getReferenceTopology(rubbingDestination.id);
            associatedTopology && intersectionData.push(associatedTopology);
            break;
        default:
            throw new Error(`Invalid rubbing destination: ${rubbingDestination}`);
    }
    return intersectionData[0];
}
export function getRubbingDestination(targetType, id, specifiedAltitude) {
    switch (targetType) {
        case ERubbingDestination.POINT_CLOUD:
            return {
                target: ERubbingDestination.POINT_CLOUD,
                id: id,
            };
        case ERubbingDestination.DESIGN_DATA:
            return {
                target: ERubbingDestination.DESIGN_DATA,
                id: id,
            };
        case ERubbingDestination.FLAT_GROUND:
            return {
                target: ERubbingDestination.FLAT_GROUND,
                id: id,
            };
        case ERubbingDestination.REFERENCE_TOPOLOGY:
            return {
                target: ERubbingDestination.REFERENCE_TOPOLOGY,
                id: id,
            };
        case ERubbingDestination.SPECIFIED_ALTITUDE:
            return {
                target: ERubbingDestination.SPECIFIED_ALTITUDE,
                specifiedAltitude: specifiedAltitude || 0,
            };
        default:
            throw new Error(`Invalid target type: ${targetType}`);
    }
}
//# sourceMappingURL=structure-utilities.js.map